import TabBlock from "../parts/tab_blocks";

document.addEventListener("DOMContentLoaded", () => {
    const masterInvoicesTabs = document.querySelector(
        ".js-master-invoices-tabs"
    );
    if (masterInvoicesTabs) {
        new TabBlock(masterInvoicesTabs).init();
    }
});
